var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: "",
      all: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "广告位置"
    }
  }, [_c("ad-position-options", {
    attrs: {
      multiple: ""
    },
    model: {
      value: _vm.searchInfo.position_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "position_id", $$v);
      },
      expression: "searchInfo.position_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色类型"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: "全部角色"
    },
    model: {
      value: _vm.searchInfo.role_type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "role_type", $$v);
      },
      expression: "searchInfo.role_type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部角色",
      value: "0"
    }
  }), _c("el-option", {
    attrs: {
      label: "新角色",
      value: "1"
    }
  }), _c("el-option", {
    attrs: {
      label: "老角色",
      value: "2"
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.searchEvent
    }
  }, [_vm._v(" 查询 ")]), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.exportEvent
    }
  }, [_vm._v(" 导出 ")])], 1)], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "position_id",
      label: "广告位置id",
      "min-width": "80",
      sortable: ""
    }
  }), _c("el-table-column", {
    attrs: {
      label: "广告位置名称",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(_vm.adPositionMap[row.position_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "watchers_count",
      label: "观看人数",
      "min-width": "100",
      sortable: ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "watch_video_count",
      label: "观看次数",
      "min-width": "100",
      sortable: ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "average_watch_video_count",
      label: "人均观看次数",
      "min-width": "100",
      sortable: ""
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };